import { PROPOSAL_ACCENT } from "@/lib/proposalTheme";
import { ChevronDown } from "lucide-react";
import { useEffect, useState } from "react";

/** Bottom-center scroll hint on the proposal cover; fades after the user scrolls. */
export default function ProposalCoverScrollCue() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY < 48);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div
      className="proposal-no-print pointer-events-none absolute inset-x-0 bottom-8 flex flex-col items-center gap-1.5 text-center print:hidden"
      data-testid="proposal-cover-scroll-cue"
    >
      <p className="text-xs font-light tracking-[0.12em]" style={{ color: PROPOSAL_ACCENT }}>
        Scroll to view proposal
      </p>
      <ChevronDown className="h-5 w-5 animate-bounce opacity-80" style={{ color: PROPOSAL_ACCENT }} aria-hidden />
    </div>
  );
}
